import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../utils/languageContext";
import "./Newhome.css";

const Sitemap = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Box className="sitemap-container">
      <Typography variant="h4" className="sitemap-title">
        {t("sitemap.title")}
      </Typography>

      <Box className="sitemap-grid">
        
        {/* HOME */}
        <div className="sitemap-section">
          <h3 onClick={() => navigate("/")}>{t("sitemap.home")}</h3>
        </div>

        {/* ABOUT */}
        <div className="sitemap-section">
          <h3 onClick={() => navigate("/")}>{t("sitemap.aboutUs")}</h3>
          <ul>
            <li onClick={() => navigate("/")}>{t("sitemap.aboutPortal")}</li>
            <li onClick={() => navigate("/")}>{t("sitemap.visionMission")}</li>
          </ul>
        </div>

        {/* PROGRAMS */}
        <div className="sitemap-section">
          <h3>{t("sitemap.programs")}</h3>
          <ul>
            <li onClick={() => window.open("https://rch.mohfw.gov.in/RCH/", "_blank")}>{t("sitemap.janani")}</li>
            <li onClick={() => window.open("https://ncd.mohfw.gov.in/", "_blank")}>{t("sitemap.ncd")}</li>
            <li onClick={() => window.open("https://pmndp.mohfw.gov.in/en", "_blank")}>{t("sitemap.pmndp")}</li>
            <li onClick={() => window.open("https://uwin.mohfw.gov.in/home", "_blank")}>{t("sitemap.uwin")}</li>
            <li onClick={() => window.open("https://nikshay.in/", "_blank")}>{t("sitemap.nikshay")}</li>
            <li onClick={() => window.open("https://sickle.nhm.gov.in/", "_blank")}>{t("sitemap.sath")}</li>
          </ul>
        </div>

        {/* SERVICES */}
        <div className="sitemap-section">
          <h3>{t("sitemap.services")}</h3>
          <ul>
            <li onClick={() => window.open("https://abdm.gov.in/", "_blank")}>{t("sitemap.abhaRegistration")}</li>
            <li onClick={() => window.open("https://nhpr.abdm.gov.in/nhpr/v4/home", "_blank")}>{t("sitemap.hpr")}</li>
            <li onClick={() => window.open("https://nhpr.abdm.gov.in/nhpr/v4/home", "_blank")}>{t("sitemap.hfr")}</li>
          </ul>
        </div>

        {/* FEATURES */}
        <div className="sitemap-section">
          <h3>{t("sitemap.keyFeatures")}</h3>
          <ul>
            <li onClick={() => navigate("/")}>{t("sitemap.unifiedHealthAccess")}</li>
            <li onClick={() => navigate("/")}>{t("sitemap.smartDecisions")}</li>
            <li onClick={() => navigate("/")}>{t("sitemap.secureAccess")}</li>
            <li onClick={() => navigate("/")}>{t("sitemap.mobileResponsive")}</li>
          </ul>
        </div>

        {/* OTHER */}
        <div className="sitemap-section">
          <h3>{t("sitemap.otherLinks")}</h3>
          <ul>
            <li onClick={() => navigate("/")}>{t("sitemap.feedback")}</li>
            <li onClick={() => navigate("/screen-reader")}>{t("sitemap.screenReader")}</li>
            <li onClick={() => navigate("/more-faq")}>{t("sitemap.faqs")}</li>
            <li onClick={() => navigate("/")}>{t("sitemap.contactUs")}</li>
          </ul>
        </div>

      </Box>
    </Box>
  );
};

export default Sitemap;